import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Stack, TextField, InputLabel } from "@mui/material";
import { getEmailConfiguration, addOrUpdateEmailConfiguration } from "../../Requests/EmailConfigurationService";
import { EmailConfigurationModel } from "../../Models/EmailConfigurationModel";


export default function EmailConfigurationView(props) {
  const [objectId, setObjectId] = useState("")
  const [service, setService] = useState("")
  const [host, setHost] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const handlePublish = async () => {
    let object = new EmailConfigurationModel()
    object.objectId = objectId
    object.emailAuthUser = email
    object.emailAuthPass = password
    object.emailAuthService = service
    object.emailAuthHost = host
    await addOrUpdateEmailConfiguration(object)
    props.publish()
  }

  const fetchEmailConfiguration = useCallback(async () => {
    const result = await getEmailConfiguration()
    if (result.length >= 1) {
      let firstItem = result[0]
      setObjectId(firstItem.objectId)
      setService(firstItem.emailAuthService)
      setHost(firstItem.emailAuthHost)
      setEmail(firstItem.emailAuthUser)
      setPassword(firstItem.emailAuthPass)
    }
  }, [])

  useEffect(() => {
    fetchEmailConfiguration()
  }, [fetchEmailConfiguration])

  return (
    <>
      <Box>
        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Service"}</InputLabel>
          <TextField
            placeholder="Gmail"
            value={service}
            onChange={(event) => setService(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Host"}</InputLabel>
          <TextField
            placeholder="smtp.gmail.com"
            value={host}
            onChange={(event) => setHost(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Email"}</InputLabel>
          <TextField
            placeholder="example@gmail.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Password"}</InputLabel>
          <TextField
            placeholder="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Set Configuration"}
        </Button>
      </Box>
    </>
  )
}
